import { render, staticRenderFns } from "./ModalEditDenuncia.vue?vue&type=template&id=7452924b"
import script from "./ModalEditDenuncia.vue?vue&type=script&lang=js"
export * from "./ModalEditDenuncia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports